module.exports = __webpack_public_path__ + "static/media/set2.ab919db4.png";